import { render, staticRenderFns } from "./Prospects.vue?vue&type=template&id=7e7d3796&scoped=true&"
import script from "./Prospects.vue?vue&type=script&lang=ts&"
export * from "./Prospects.vue?vue&type=script&lang=ts&"
import style0 from "./Prospects.vue?vue&type=style&index=0&id=7e7d3796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7d3796",
  null
  
)

export default component.exports